import { render, staticRenderFns } from "./OrderTtn.vue?vue&type=template&id=f973d0d4&scoped=true"
import script from "./OrderTtn.vue?vue&type=script&lang=js"
export * from "./OrderTtn.vue?vue&type=script&lang=js"
import style0 from "./OrderTtn.vue?vue&type=style&index=0&id=f973d0d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f973d0d4",
  null
  
)

export default component.exports